// Mock data for Smith, hookah supply Co.

export const products = [
  {
    id: '1',
    name: 'Royal Palace Hookah',
    category: 'hookahs',
    price: 299.99,
    description: 'Luxury handcrafted hookah with premium gold finish and intricate detailing',
    image: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&h=800&fit=crop',
    stock: 15,
    featured: true
  },
  {
    id: '2',
    name: 'Premium Mint Tobacco',
    category: 'tobacco',
    price: 24.99,
    description: 'Smooth mint flavor tobacco blend, 250g package',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=800&fit=crop',
    stock: 50,
    featured: true
  },
  {
    id: '3',
    name: 'Gold Plated Mouthpiece Set',
    category: 'accessories',
    price: 49.99,
    description: 'Elegant gold-plated mouthpiece set of 4 pieces',
    image: 'https://images.unsplash.com/photo-1608528986310-f6815970f2a9?w=800&h=800&fit=crop',
    stock: 30,
    featured: false
  },
  {
    id: '4',
    name: 'Elite Glass Base',
    category: 'accessories',
    price: 89.99,
    description: 'Crystal clear handblown glass base with gold accents',
    image: 'https://images.unsplash.com/photo-1545486332-9e0999c535b2?w=800&h=800&fit=crop',
    stock: 20,
    featured: true
  },
  {
    id: '5',
    name: 'Exotic Fruit Mix Tobacco',
    category: 'tobacco',
    price: 29.99,
    description: 'Premium fruit blend tobacco, 250g package',
    image: 'https://images.unsplash.com/photo-1557800636-894a64c1696f?w=800&h=800&fit=crop',
    stock: 45,
    featured: false
  }
];

export const categories = [
  { id: 'all', name: 'All Products', icon: 'Grid' },
  { id: 'hookahs', name: 'Hookahs', icon: 'Flame' },
  { id: 'tobacco', name: 'Tobacco', icon: 'Leaf' },
  { id: 'accessories', name: 'Accessories', icon: 'Star' }
];

export const mockOrders = [
  {
    id: 'ORD-001',
    date: '2025-08-15',
    total: 374.98,
    status: 'delivered',
    items: [
      { productId: '1', quantity: 1, price: 299.99 },
      { productId: '2', quantity: 3, price: 24.99 }
    ]
  },
  {
    id: 'ORD-002',
    date: '2025-08-18',
    total: 139.98,
    status: 'processing',
    items: [
      { productId: '4', quantity: 1, price: 89.99 },
      { productId: '3', quantity: 1, price: 49.99 }
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Marcus Johnson',
    rating: 5,
    text: 'Exceptional quality and service. The Royal Palace Hookah exceeded all my expectations!',
    date: '2025-08-10'
  },
  {
    id: 2,
    name: 'Sarah Williams',
    rating: 5,
    text: 'Best tobacco selection I\'ve found online. Fast shipping and premium products.',
    date: '2025-08-12'
  },
  {
    id: 3,
    name: 'Ahmed Hassan',
    rating: 5,
    text: 'The gold accessories are absolutely stunning. True luxury quality.',
    date: '2025-08-14'
  }
];

export const socialLinks = [
  { name: 'Instagram', url: 'https://instagram.com', icon: 'Instagram' },
  { name: 'Facebook', url: 'https://facebook.com', icon: 'Facebook' },
  { name: 'Twitter', url: 'https://twitter.com', icon: 'Twitter' },
  { name: 'YouTube', url: 'https://youtube.com', icon: 'Youtube' }
];